export function DevTab({ autoNav, setAutoNav, droneCount, setDroneCount, devSpawnRate, setDevSpawnRate, devQueueMax, setDevQueueMax, openTrade, devFreeFuel, setDevFreeFuel, devRevealAll, setDevRevealAll, devInstantSmelt, setDevInstantSmelt, simulateOffline, resetStarmap, addEchoCurrency, addVoidShards, rollCardDrop }) {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <div style={{ padding: "12px 14px 6px", flexShrink: 0 }}>
        <div style={{ fontSize: 12, letterSpacing: 1, color: "rgba(255,200,0,0.8)", marginBottom: 2, fontWeight: 700 }}>⚗ DEV TOOLS</div>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginBottom: 10 }}>Testing controls — not part of the game.</div>
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "0 14px 14px", display: "flex", flexDirection: "column", gap: 10 }}>

        {/* Auto-nav */}
        <div>
          <button onClick={() => setAutoNav(v => !v)}
            style={{ width: "100%", padding: "10px 13px", background: autoNav ? "rgba(0,220,150,0.12)" : "rgba(255,255,255,0.03)", border: `1px solid ${autoNav ? "rgba(0,220,150,0.4)" : "rgba(255,255,255,0.1)"}`, borderRadius: 7, color: autoNav ? "#33ffaa" : "rgba(255,255,255,0.55)", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "all 0.2s" }}>
            <span>🤖 Auto-Navigate &amp; Harvest</span>
            <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4, background: autoNav ? "rgba(0,220,150,0.2)" : "rgba(255,255,255,0.07)", color: autoNav ? "#33ffaa" : "rgba(255,255,255,0.35)" }}>{autoNav ? "ON" : "OFF"}</span>
          </button>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 4 }}>Ship automatically moves to and destroys the nearest debris.</div>
        </div>

        {/* Combat drones */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 13px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 7 }}>
          <div>
            <div style={{ fontSize: 13, color: "rgba(255,200,80,0.9)", fontWeight: 700 }}>🛸 Combat Drones</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 2 }}>Each drone independently hunts debris.</div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button onClick={() => setDroneCount(v => Math.max(0, v - 1))} style={btnStyle}>−</button>
            <span style={{ fontSize: 16, fontWeight: 700, color: "#ffcc44", minWidth: 20, textAlign: "center" }}>{droneCount}</span>
            <button onClick={() => setDroneCount(v => Math.min(10, v + 1))} style={btnStyleYellow}>+</button>
          </div>
        </div>

        {/* Debris spawn rate */}
        <div style={{ padding: "10px 13px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 7 }}>
          <div style={{ fontSize: 13, color: "rgba(255,200,80,0.9)", fontWeight: 700, marginBottom: 8 }}>☄ Debris Spawn Rate</div>
          <div style={{ display: "flex", gap: 6 }}>
            {[1, 2, 5, 10].map(v => (
              <button key={v} onClick={() => setDevSpawnRate(v)}
                style={{ flex: 1, padding: "7px 0", background: devSpawnRate === v ? "rgba(255,160,0,0.18)" : "rgba(255,255,255,0.04)", border: `1px solid ${devSpawnRate === v ? "rgba(255,160,0,0.55)" : "rgba(255,255,255,0.1)"}`, borderRadius: 6, color: devSpawnRate === v ? "#ffaa33" : "rgba(255,255,255,0.45)", fontFamily: "inherit", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                ×{v}
              </button>
            ))}
          </div>
        </div>

        {/* Open Trade Outpost */}
        <div>
          <button onClick={openTrade}
            style={{ width: "100%", padding: "10px 13px", background: "rgba(51,255,204,0.07)", border: "1px solid rgba(51,255,204,0.3)", borderRadius: 7, color: "#33ffcc", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer", textAlign: "left" }}>
            🏪 Open Trade Outpost
          </button>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 4 }}>Force-opens the trade tab regardless of node type.</div>
        </div>

        {/* Free fuel */}
        <div>
          <button onClick={() => setDevFreeFuel(v => !v)}
            style={{ width: "100%", padding: "10px 13px", background: devFreeFuel ? "rgba(255,220,0,0.12)" : "rgba(255,255,255,0.03)", border: `1px solid ${devFreeFuel ? "rgba(255,220,0,0.4)" : "rgba(255,255,255,0.1)"}`, borderRadius: 7, color: devFreeFuel ? "#ffdd33" : "rgba(255,255,255,0.55)", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "all 0.2s" }}>
            <span>⛽ Free Fuel</span>
            <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4, background: devFreeFuel ? "rgba(255,220,0,0.2)" : "rgba(255,255,255,0.07)", color: devFreeFuel ? "#ffdd33" : "rgba(255,255,255,0.35)" }}>{devFreeFuel ? "ON" : "OFF"}</span>
          </button>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 4 }}>All travel costs 0 fuel. Depots still give fuel.</div>
        </div>

        {/* Reveal all nodes */}
        <div>
          <button onClick={() => setDevRevealAll(v => !v)}
            style={{ width: "100%", padding: "10px 13px", background: devRevealAll ? "rgba(100,180,255,0.12)" : "rgba(255,255,255,0.03)", border: `1px solid ${devRevealAll ? "rgba(100,180,255,0.4)" : "rgba(255,255,255,0.1)"}`, borderRadius: 7, color: devRevealAll ? "#aaddff" : "rgba(255,255,255,0.55)", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "all 0.2s" }}>
            <span>🗺️ Discover All Nodes</span>
            <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4, background: devRevealAll ? "rgba(100,180,255,0.2)" : "rgba(255,255,255,0.07)", color: devRevealAll ? "#aaddff" : "rgba(255,255,255,0.35)" }}>{devRevealAll ? "ON" : "OFF"}</span>
          </button>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 4 }}>Marks every node in the current sector as visited.</div>
        </div>

        {/* Reset starmap */}
        <div>
          <button onClick={() => resetStarmap()}
            style={{ width: "100%", padding: "10px 13px", background: "rgba(255,60,60,0.08)", border: "1px solid rgba(255,60,60,0.3)", borderRadius: 7, color: "#ff6666", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer", textAlign: "left" }}>
            🗺️ Undiscover Starmap
          </button>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 4 }}>Resets all visited nodes — only the starting node remains discovered.</div>
        </div>

        {/* Instant smelt */}
        <div>
          <button onClick={() => setDevInstantSmelt(v => !v)}
            style={{ width: "100%", padding: "10px 13px", background: devInstantSmelt ? "rgba(255,120,0,0.12)" : "rgba(255,255,255,0.03)", border: `1px solid ${devInstantSmelt ? "rgba(255,120,0,0.4)" : "rgba(255,255,255,0.1)"}`, borderRadius: 7, color: devInstantSmelt ? "#ff9944" : "rgba(255,255,255,0.55)", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "all 0.2s" }}>
            <span>⚡ Instant Smelt</span>
            <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4, background: devInstantSmelt ? "rgba(255,120,0,0.2)" : "rgba(255,255,255,0.07)", color: devInstantSmelt ? "#ff9944" : "rgba(255,255,255,0.35)" }}>{devInstantSmelt ? "ON" : "OFF"}</span>
          </button>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 4 }}>Smelt recipes complete instantly with no timer.</div>
        </div>

        {/* Simulate offline */}
        <div style={{ padding: "10px 13px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 7 }}>
          <div style={{ fontSize: 13, color: "rgba(255,200,80,0.9)", fontWeight: 700, marginBottom: 8 }}>⏰ Simulate Offline Time</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {[
              { label: "10m",  ms: 10 * 60 * 1000 },
              { label: "30m",  ms: 30 * 60 * 1000 },
              { label: "1h",   ms: 60 * 60 * 1000 },
              { label: "4h",   ms: 4 * 60 * 60 * 1000 },
              { label: "8h",   ms: 8 * 60 * 60 * 1000 },
            ].map(({ label, ms }) => (
              <button key={label} onClick={() => simulateOffline(ms)}
                style={{ flex: 1, minWidth: 44, padding: "7px 0", background: "rgba(255,160,0,0.08)", border: "1px solid rgba(255,160,0,0.3)", borderRadius: 6, color: "#ffaa33", fontFamily: "inherit", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                {label}
              </button>
            ))}
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 6 }}>Shows the offline modal with gains from the current node's drop pool.</div>
        </div>

        {/* Rift Echoes dev tools */}
        <div style={{ padding: "10px 13px", background: "rgba(187,119,255,0.05)", border: "1px solid rgba(187,119,255,0.18)", borderRadius: 7 }}>
          <div style={{ fontSize: 13, color: "#bb77ff", fontWeight: 700, marginBottom: 8 }}>〰️ Rift Echoes</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {[100, 500, 2000, 10000].map(amt => (
              <button key={amt} onClick={() => addEchoCurrency?.(amt)}
                style={{ flex: 1, minWidth: 52, padding: "7px 0", background: "rgba(187,119,255,0.1)", border: "1px solid rgba(187,119,255,0.3)", borderRadius: 6, color: "#bb77ff", fontFamily: "inherit", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                +{amt} 〰️
              </button>
            ))}
          </div>
          <div style={{ display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap" }}>
            <button onClick={() => addVoidShards?.(10)}
              style={{ flex: 1, padding: "7px 0", background: "rgba(255,204,34,0.1)", border: "1px solid rgba(255,204,34,0.3)", borderRadius: 6, color: "#ffcc22", fontFamily: "inherit", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
              +10 ◈ Void Shards
            </button>
            <button onClick={() => { const c = rollCardDrop?.(); if (c) alert(`Dropped: ${c.name}`); else alert("All cards owned!"); }}
              style={{ flex: 1, padding: "7px 0", background: "rgba(187,119,255,0.08)", border: "1px solid rgba(187,119,255,0.25)", borderRadius: 6, color: "#bb77ff", fontFamily: "inherit", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
              🎲 Drop Random Card
            </button>
          </div>
        </div>

        {/* Smelt queue size */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 13px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 7 }}>
          <div>
            <div style={{ fontSize: 13, color: "rgba(255,200,80,0.9)", fontWeight: 700 }}>📦 Smelt Queue Size</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 2 }}>Override queue cap for testing.</div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button onClick={() => setDevQueueMax(v => Math.max(1, v - 1))} style={btnStyle}>−</button>
            <span style={{ fontSize: 16, fontWeight: 700, color: "#ffcc44", minWidth: 20, textAlign: "center" }}>{devQueueMax}</span>
            <button onClick={() => setDevQueueMax(v => Math.min(20, v + 1))} style={btnStyleYellow}>+</button>
          </div>
        </div>

      </div>
    </div>
  );
}

const btnStyle = { width: 32, height: 32, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 6, color: "rgba(255,255,255,0.6)", fontSize: 18, cursor: "pointer", fontFamily: "inherit", lineHeight: 1 };
const btnStyleYellow = { width: 32, height: 32, background: "rgba(255,200,0,0.08)", border: "1px solid rgba(255,200,0,0.25)", borderRadius: 6, color: "#ffcc44", fontSize: 18, cursor: "pointer", fontFamily: "inherit", lineHeight: 1 };
